import { render } from "./SingleView.vue?vue&type=template&id=5830638d"
import script from "./SingleView.vue?vue&type=script&lang=js"
export * from "./SingleView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__